function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { LOADING_STATUS_VALUE } from './AbstractLayerHandler.ol';
export var RequestCounter = /*#__PURE__*/function () {
  function RequestCounter() {
    _classCallCheck(this, RequestCounter);
    this._init();
  }
  return _createClass(RequestCounter, [{
    key: "_init",
    value: function _init() {
      this.started = 0;
      this.errors = 0;
      this.completed = 0;
      this.lastStatusUpdate = null;
    }
  }, {
    key: "isFirstPending",
    value: function isFirstPending() {
      return this.started === 1 && this.completed + this.errors === 0;
    }
  }, {
    key: "hasAllFailed",
    value: function hasAllFailed() {
      return this.errors >= this.started;
    }
  }, {
    key: "isFinished",
    value: function isFinished() {
      return this.completed + this.errors >= this.started;
    }
  }, {
    key: "isPending",
    value: function isPending() {
      return this.started > this.completed + this.errors;
    }

    /**
     * @method getFinishedStatus
     * @return Loading status if all pending requests have been received, else null.
     */
  }, {
    key: "getFinishedStatus",
    value: function getFinishedStatus() {
      if (this.isPending()) {
        return null;
      }
      if (this.hasAllFailed()) {
        return LOADING_STATUS_VALUE.ERROR;
      }
      return LOADING_STATUS_VALUE.COMPLETE;
    }
  }, {
    key: "getLastStatusUpdate",
    value: function getLastStatusUpdate() {
      return this.lastStatusUpdate;
    }
  }, {
    key: "update",
    value: function update(status) {
      switch (status) {
        case LOADING_STATUS_VALUE.LOADING:
          this.started++;
          break;
        case LOADING_STATUS_VALUE.COMPLETE:
          this.completed++;
          break;
        case LOADING_STATUS_VALUE.ERROR:
          this.errors++;
          break;
      }
      this.lastStatusUpdate = status;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._init();
    }
  }]);
}();